import { CheckoutState } from '../reducers';
import { createSelector } from 'reselect';

export const getServicesSavingState = (state: CheckoutState) => state.servicesIsSaving;

export const isServicesSaving = createSelector(getServicesSavingState, (isLoading: boolean) => isLoading);
